import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Prompt, useHistory, useParams } from 'react-router-dom'
import { Row, Col, Space, Spin, Tooltip, notification, message } from 'antd'
import { SiderLayout } from 'modules/core/layouts'
import {
  ActionModal,
  Button,
  CreationExitModal,
  KPIsGlobalDetail,
  PeriodNavigator,
  ProjectionSelects,
  ScreenWellDone,
  ToolsDrawer,
  UserActionsGlobalDetail,
} from 'modules/core/components'
import { TabsReports } from './components'
import { useTranslation } from 'react-i18next'
import {
  generateMessageError,
  getBudgetSelected,
  getOperationsByKeys,
  getStepsOfInstances,
  isApproved,
  isPublished,
  isUserAllowed,
  sendUserDataToGTM,
} from 'modules/core/utils'
import { ROLES, PROJECTION, GENERAL, TAB_KEYS } from 'modules/core/constants'
import { client } from 'httpclient'
import { onSetDefaultForecast } from './utils'
import { useDefaultCurrency } from 'modules/core/customHooks'
import imageDefault from 'assets/images/compositions/feedback-image.svg'
import reports from 'modules/reports'
import planning from 'modules/planning'
import configuration from 'modules/configuration'
import forecast from 'modules/forecast'
import moment from 'moment'
import login from 'modules/login'
import PropTypes from 'prop-types'

import './GlobalForecastDetail.scss'
import _ from 'lodash'
import control from 'modules/control'

const { FORECAST__GLOBAL_FORECAST__ABM, SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES } = ROLES

const GlobalForecastDetail = ({
  globalForecastDetail,
  fetchBudgetTypeList,
  analysisList,
  fetchAnalysisList,
  approveGlobalForecast,
  setDefaultForecast,
  publishGlobalForecast,
  fetchGlobalForecastDetail,
  periodList,
  changeProjectionForecast,
  fetchDataEvolutionByOverallForecast,
  fetchDataComparativeByOverallForecast,
  applyRuleForecast,
  unApplyRuleForecast,
  fetchAllDimensions,
  allDimensionsList,
  fetchCurrencyList,
  currencyList,
  fetchCommentsList,
  commentsList,
  fetchForecasts,
  forecasts,
  fetchGlobalBudgetKpi,
  globalBudgetKpi,
  applyUnapplyMassiveGlobalForecast,
  loggedUser,
  shareLayout,
}) => {
  const enableKpis = useFeatureIsOn('feature-visible-kpi')
  let { periodId, forecastId, globalForecastId, reportId, currency, base, tableType } = useParams()
  const [isScreenLoading, setIsScreenLoading] = useState(false)
  const [isBudgetLoading, setIsBudgetLoading] = useState(false)
  const [tableId, setTableId] = useState(reportId || null)
  const [showActionModal, setShowActionModal] = useState(null)
  const [showScreenSuccess, setShowScreenSuccess] = useState(null)
  const [options, setOptions] = useState([])
  const [selectedDates] = useState({})
  const [filters] = useState({})
  const [showDrawerRules, setShowDrawerRules] = useState(false)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [defaultPhase, setDefaultPhase] = useState(base || PROJECTION.BASE_KEY)
  const [isCurrencyLoading, setIsCurrencyLoading] = useState(false)
  const [currencyChange, setCurrencyChange] = useState(null)
  const [dataComments, setDataComments] = useState([])
  const [isLoadingComments, setIsLoadingComments] = useState(false)
  const [applyRuleB, setApplyRuleB] = useState(false)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [isKpiLoading, setIsKpiLoading] = useState(false)
  const [showAlert, setShowAlert] = useState({
    kpi: false,
    comparison: false,
    evolution: false,
    chart: false,
    rule: false,
    exchangeRate: false,
  })
  const [showExitModal, setShowExitModal] = useState(false)
  const [lastLocation, setLastLocation] = useState(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const [settingsEvolution, setSettingsEvolution] = useState({})
  const [settingsComparison, setSettingsComparison] = useState({})
  const [tableKey, setTableKey] = useState(tableType || TAB_KEYS.TAB_KEY_EVOLUTION)

  const defaultCurrencyData = useDefaultCurrency()
  const { t } = useTranslation()
  let history = useHistory()

  const auxCurrencyId = currencyChange ? currencyChange : defaultCurrencyData?.id
  const key = window.location.pathname.replaceAll('/', '-')
  const currencyData = currencyChange
    ? currencyList.data.find((el) => el.id === currencyChange)
    : defaultCurrencyData

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault()
      window.confirm('Puede que haya cambios sin guardar, deseas volver atrás?')
    }

    if (
      showAlert.comparison ||
      showAlert.kpi ||
      showAlert.evolution ||
      showAlert.chart ||
      showAlert.rule ||
      showAlert.exchangeRate
    ) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    if (
      !showAlert.comparison &&
      !showAlert.kpi &&
      !showAlert.evolution &&
      !showAlert.chart &&
      !showAlert.rule &&
      !showAlert.exchangeRate
    ) {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [
    showAlert.kpi,
    showAlert.comparison,
    showAlert.evolution,
    showAlert.chart,
    showAlert.exchangeRate,
    showAlert.rule,
  ])

  useEffect(() => {
    if ((currency && currencyChange) || (!currency && currencyChange)) {
      setCurrencyChange(auxCurrencyId)
    } else {
      setCurrencyChange(parseInt(currency))
    }
  }, [currency, auxCurrencyId, currencyChange])

  useEffect(() => {
    setIsLoadingComments(true)
    fetchCommentsList({ module: key }).then(() => setIsLoadingComments(false))
  }, [fetchCommentsList, key])

  useEffect(() => {
    setDataComments(commentsList)
  }, [commentsList])

  useEffect(() => {
    setIsScreenLoading(true)
    fetchGlobalForecastDetail(globalForecastId).then(() => setIsScreenLoading(false))
  }, [fetchGlobalForecastDetail, globalForecastId])

  useEffect(() => {
    fetchAnalysisList().then((data) => {
      if (data.payload.data.length > 0) {
        if (reportId) {
          setTableId(reportId)
        } else {
          setTableId(data.payload.data[0].id)
        }
      }
    })
  }, [fetchAnalysisList, reportId])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions])

  useEffect(() => {
    fetchForecasts({ period_id: periodId })
  }, [fetchForecasts, periodId])

  useEffect(() => {
    if (currencyData) {
      setIsKpiLoading(true)
      fetchGlobalBudgetKpi(periodId, globalForecastId, {
        budget_type: 'forecast',
        currency_id: currencyData.id,
      }).then(() => {
        setIsKpiLoading(false)
      })
    }
  }, [fetchGlobalBudgetKpi, periodId, globalForecastId, currencyData])

  //todo: revisar
  useEffect(() => {
    const fetchBudgetData = async () => {
      try {
        const response = await fetchBudgetTypeList()
        const concepts = response.payload.data.concepts

        for (const concept of concepts) {
          setIsBudgetLoading(true)

          const resp = await client.get(`/planning/forecast/get_kpis/${forecastId}/${concept.id}/`)

          const aux = resp.data.map((budget) => ({
            ...budget,
            conceptId: concept.id,
          }))

          setOptions((prevState) => [...prevState, ...aux])
          setIsBudgetLoading(false)
        }
      } catch (error) {
        console.error('Error fetching budget data:', error)
        setIsBudgetLoading(false)
      }
    }

    fetchBudgetData()
  }, [fetchBudgetTypeList, forecastId])

  useEffect(() => {
    setIsCurrencyLoading(true)
    fetchCurrencyList().then(() => {
      setIsCurrencyLoading(false)
    })
  }, [fetchCurrencyList])

  const isGlobalBudgetApproved = isApproved(globalForecastDetail?.status)
  const isGlobalBudgetPublished = isPublished(globalForecastDetail?.status)
  const isActionApprove = isApproved(showActionModal)
  const userCanAction = isUserAllowed(FORECAST__GLOBAL_FORECAST__ABM)
  const userCanViewAndABMRules = isUserAllowed(
    getOperationsByKeys([SETTINGS__PROJECTION_ELEMENTS__BUSINESS_RULES]),
  )
  const dataPeriod = periodList.find((el) => el.id === parseInt(periodId))
  const notForecastClosed = getBudgetSelected(globalForecastDetail?.budgets_ids, options)
    ? getBudgetSelected(globalForecastDetail?.budgets_ids, options).some((el) => !el?.is_closing)
    : true

  const renderHeader = () => (
    <PeriodNavigator
      items={[
        {
          name: t('LABEL_FORECAST'),
          url: `/forecast/${periodId}`,
        },
        {
          name: `${t('LABEL_DETAIL')}: ${t('LABEL_FORECAST')}`,
          url: `/forecast/${periodId}/${forecastId}/${PROJECTION.GLOBAL_FORECAST}`,
        },
        { name: globalForecastDetail?.name },
      ]}
    />
  )

  const renderSelectors = () => (
    <ProjectionSelects
      loading={isBudgetLoading}
      idsBudgetsSelected={globalForecastDetail?.budgets_ids}
      disabled={isGlobalBudgetApproved}
      options={options}
      globalProjectionId={globalForecastId}
      changeProjection={changeProjectionForecast}
      onRefetchGobalBudgetDetail={onRefetchAll}
    />
  )

  const onRefetchAll = () => {
    setIsKpiLoading(true)
    setShowAlert((prevState) => {
      return { ...prevState, evolution: true, comparison: true, kpi: true }
    })
    Promise.all([
      onRefetch(),
      fetchGlobalForecastDetail(globalForecastId),
      fetchGlobalBudgetKpi(periodId, globalForecastId, {
        budget_type: 'forecast',
        currency_id: currencyData.id,
      }),
    ]).then(() => {
      setIsKpiLoading(false)
      setShowAlert((prevState) => {
        return { ...prevState, evolution: false, comparison: false, kpi: false }
      })
    })
  }

  const handleClick = (key) => {
    setCurrencyChange(key)
    window.history.replaceState(
      null,
      '',
      `/forecast/${periodId}/${forecastId}/forecastglobal/${globalForecastId}/${key}`,
    )
  }

  const handleOnClickCompartir = () => {
    const dataSettings = {
      ...(tableKey === 'evolution' && {
        ...settingsEvolution,
      }),
      ...(tableKey === 'comparison' && {
        ...settingsComparison,
      }),
    }

    const extraKey = tableKey === 'evolution' ? 'montly_evolution' : 'coparations'

    const {
      aggregatorName,
      cols,
      columns,
      default_format,
      default_value,
      rendererName,
      vals,
      valueFilter,
      rows,
    } = dataSettings

    const dataTable = {
      ...(!_.isEmpty(dataSettings) && {
        aggregatorName,
        cols,
        columns,
        default_format,
        default_value,
        rendererName,
        vals,
        valueFilter,
        rows,
      }),
    }

    const urlObj = new URL(window.location.href)
    const pathAndQuery = urlObj.pathname + urlObj.search

    shareLayout('forecastoverallbudget', `${globalForecastId}-${tableId}-${extraKey}`, {
      path: pathAndQuery,
      config: { ...dataTable },
    })
      .then((response) => {
        message.success(t('FEEDBACK_COPY_URL_SUCCESS'), 8)
        const newUrl = response.payload.data.url_hash
        // .replace(
        //   'https://stg.getplika.com/',
        //   'http://localhost:3000/',
        // )
        navigator.clipboard.writeText(newUrl)
      })
      .catch((error) => {
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const renderUserActions = () => (
    <UserActionsGlobalDetail
      onClickPublish={() => setShowActionModal(PROJECTION.STATUS.PUBLISHED)}
      disabledPublish={isGlobalBudgetPublished || isGlobalBudgetApproved || !userCanAction}
      buttonPublishName={isGlobalBudgetPublished ? t('STATE_TAG_PUBLISHED') : t('ACTION_PUBLISH')}
      tooltipApprove={
        !isGlobalBudgetPublished && !isGlobalBudgetApproved ? t('TOOLTIP_NOT_APPROVE_TITLE') : ''
      }
      onClickApprove={() => setShowActionModal(PROJECTION.STATUS.APPROVED)}
      disableApprove={
        !userCanAction || isGlobalBudgetApproved || !isGlobalBudgetPublished || notForecastClosed
      }
      buttonApproveName={isGlobalBudgetApproved ? t('STATE_TAG_APPROVED') : t('ACTION_APPROVE')}
      onClickApply={() => setShowDrawerRules(true)}
      extraButtons={{
        module_name: 'forecast_global',
        submodule_name: globalForecastId,
      }}
      currencyOptions={currencyList.data}
      onChangeCurrency={(val) => handleClick(val)}
      defaultCurrency={currencyChange ? currencyChange : defaultCurrencyData?.id}
      onClickActivity={() =>
        history.push(
          `/forecast/${periodId}/${forecastId}/forecastglobal/${globalForecastId}/${
            currencyChange
              ? currencyList.data.find((el) => el.id === currencyChange)?.id
              : defaultCurrencyData?.id
          }/${tableId}/evolution/base/actividad?type=forecast_overall_budget&module=globalForecastDetail`,
        )
      }
      onClickCompartir={() => handleOnClickCompartir()}
    />
  )

  const renderReportsTables = () => (
    <TabsReports
      tableId={tableId}
      setTableId={setTableId}
      loading={isScreenLoading}
      stepsForecastInstance={getStepsOfInstances(globalForecastDetail, options)}
      dataPeriod={dataPeriod}
      globalForecastName={globalForecastDetail?.name}
      selectedDates={selectedDates}
      filters={filters}
      tableLoading={isTableLoading}
      allDimensionsList={allDimensionsList}
      defaultPhase={defaultPhase}
      setDefaultPhase={setDefaultPhase}
      auxCurrencyId={auxCurrencyId}
      setDataComments={setDataComments}
      dataComments={dataComments}
      onRefetchComments={() => fetchCommentsList({ module: key })}
      loadingComments={isLoadingComments}
      currencyData={
        currencyChange
          ? currencyList.data.find((el) => el.id === currencyChange)
          : defaultCurrencyData
      }
      showProgressBar={showProgressBar}
      setShowProgressBar={setShowProgressBar}
      settingsComparison={settingsComparison}
      settingsEvolution={settingsEvolution}
      setSettingsComparison={setSettingsComparison}
      setSettingsEvolution={setSettingsEvolution}
      tableKey={tableKey}
      setTableKey={setTableKey}
    />
  )

  const onRefetch = () => {
    setIsTableLoading(true)
    setShowProgressBar(true)
    setShowAlert((prevState) => {
      return { ...prevState, evolution: true, comparison: true }
    })
    Promise.all([
      fetchDataEvolutionByOverallForecast(tableId, parseInt(globalForecastId), defaultPhase, {
        ...(auxCurrencyId && { currency_id: auxCurrencyId }),
      }),
      fetchDataComparativeByOverallForecast(tableId, parseInt(globalForecastId), {
        ...(auxCurrencyId && { currency_id: auxCurrencyId }),
      }),
    ]).then(() => {
      setIsTableLoading(false)
      setShowAlert((prevState) => {
        return { ...prevState, evolution: false, comparison: false }
      })
      setTimeout(() => {
        setShowProgressBar(false)
      }, 2000)
    })
  }

  const handleClose = () => {
    setShowDrawerRules(false)
    if (applyRuleB) {
      console.log('applyRule', applyRuleB)
      onRefetch()
    }
    setApplyRuleB(false)
  }

  const handleApplyRule = (ruleId) => {
    setApplyRuleB(true)

    return applyRuleForecast(globalForecastId, ruleId, { period: periodId })
  }

  const handleUnApplyRule = (ruleId) => {
    setApplyRuleB(true)

    return unApplyRuleForecast(globalForecastId, ruleId, { period: periodId })
  }

  const handleExitConfirm = () => {
    if (lastLocation) {
      setShowExitModal(false)
      history.push(lastLocation)
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
    } else {
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
      history.push(`/forecast/${periodId}/${forecastId}/${PROJECTION.GLOBAL_FORECAST}/`)
    }
  }

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation) {
      setShowExitModal(true)
      setLastLocation(nextLocation)
      setConfirmedNavigation(true)
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
      return false
    } else {
      setShowAlert({
        kpi: false,
        comparison: false,
        evolution: false,
        chart: false,
        rule: false,
        exchangeRate: false,
      })
      return true
    }
  }

  return (
    <SiderLayout className="container-global-budget-detail">
      <Prompt
        when={
          showAlert.kpi ||
          showAlert.comparison ||
          showAlert.evolution ||
          showAlert.chart ||
          showAlert.rule ||
          showAlert.exchangeRate
        }
        message={handleBlockedNavigation}
      />
      {renderHeader()}
      <Spin spinning={isScreenLoading} />
      {globalForecastDetail && !isScreenLoading && (
        <>
          {!showScreenSuccess && (
            <>
              <Row gutter={[8, 24]}>
                <Col span={24}>{renderUserActions()}</Col>
                <Col span={24}>{renderSelectors()}</Col>
                <Col span={24}>
                  {enableKpis && (
                    <KPIsGlobalDetail
                      globalBudgetKpi={globalBudgetKpi}
                      setDataComments={setDataComments}
                      dataComments={dataComments}
                      onRefetchComments={() => fetchCommentsList({ module: key })}
                      loadingComments={isLoadingComments}
                      currencyData={
                        currencyChange
                          ? currencyList.data.find((el) => el.id === currencyChange)
                          : defaultCurrencyData
                      }
                      isKpiLoading={isKpiLoading}
                    />
                  )}
                </Col>
                <Col span={24}>{analysisList?.count > 0 && renderReportsTables()}</Col>
              </Row>
              <ActionModal
                globalBudgetId={globalForecastId}
                isActionApprove={isActionApprove}
                visible={showActionModal}
                onAction={isActionApprove ? approveGlobalForecast : publishGlobalForecast}
                onFetchDetail={() => fetchGlobalForecastDetail(globalForecastId)}
                onConfirm={() => setShowScreenSuccess(showActionModal)}
                onClose={() => setShowActionModal(null)}
                sendUserDataToGTM={() =>
                  sendUserDataToGTM(
                    loggedUser,
                    'Forecast global',
                    `${isActionApprove ? 'Aprobar' : 'Publicar'} forecast global`,
                    `${isActionApprove ? 'Aprobación' : 'Publicación'}`,
                  )
                }
              />
              <ToolsDrawer
                onRefetchDataTable={onRefetch}
                visible={showDrawerRules}
                onClose={() => handleClose()}
                periodId={periodId}
                hasRule={true}
                globalProjectionId={globalForecastId}
                type="forecast_overall_budget"
                applyRule={(ruleId) => handleApplyRule(ruleId)}
                unApplyRule={(ruleId) => handleUnApplyRule(ruleId)}
                typeModule={GENERAL.MODULES_KEYS.MODULE_FORECAST_OVERALL}
                moduleId={globalForecastId}
                hasCurrency={true}
                isCurrencyLoading={isCurrencyLoading}
                currencyList={currencyList}
                params={{
                  overall_budget_id: globalForecastId,
                  module: 'OVERALL_FORECAST',
                }}
                disabledRule={!userCanViewAndABMRules || isGlobalBudgetApproved}
                disabledCurrency={!userCanAction || isGlobalBudgetApproved}
                disabledDate={{
                  cutDate:
                    forecasts?.values.length > 0
                      ? forecasts?.values.find((el) => el.id === parseInt(forecastId))?.year_month
                      : '',
                  startDatePeriod: moment(dataPeriod?.start_date).utc().format('YYYY-MM-DD'),
                }}
                setShowAlert={setShowAlert}
                applyUnappluMassive={applyUnapplyMassiveGlobalForecast}
                extraDataApplyUnapply={{
                  card_id: globalForecastId,
                }}
                setApplyRuleB={setApplyRuleB}
              />
            </>
          )}
          {showScreenSuccess && (
            <ScreenWellDone
              image={imageDefault}
              title={t('FEEDBACK_WELLDONE')}
              description={t('PLANNING_SCREEN_SUCCESS_FEEDBACK', {
                period: dataPeriod?.name,
                action: isActionApprove
                  ? t('ACTION_APPROVE').toLowerCase()
                  : t('ACTION_PUBLISH').toLowerCase(),
              })}
              footer={
                <Space>
                  <Button.Primary
                    onClick={() => setShowScreenSuccess(null)}
                    title="ACTION_FINISH"
                  />
                  {!isGlobalBudgetApproved && (
                    <Tooltip title={t('PLANNING_GLOBAL_BUDGET_INFORMATIVE_TOOLTIP_TITLE')}>
                      <Button.Default
                        onClick={() =>
                          onSetDefaultForecast({
                            setDefaultForecast: () => setDefaultForecast(globalForecastId),
                            setShowScreenSuccess,
                            sendUserDataToGTM: () =>
                              sendUserDataToGTM(
                                loggedUser,
                                'Forecast global',
                                `Fijar forecast global`,
                                `Fijación`,
                              ),
                          })
                        }
                        title="ACTION_FIX"
                      />
                    </Tooltip>
                  )}
                </Space>
              }
            />
          )}
          <CreationExitModal
            visible={showExitModal}
            onClose={() => {
              setShowExitModal(false)
              setConfirmedNavigation(false)
              setShowAlert({
                kpi: false,
                comparison: false,
                evolution: false,
                chart: false,
                rule: false,
                exchangeRate: false,
              })
            }}
            onConfirm={handleExitConfirm}
          />
        </>
      )}
    </SiderLayout>
  )
}

const mapStateToProps = (state) => ({
  globalForecastDetail: forecast.selectors.getGlobalForecastDetail(state),
  analysisList: reports.selectors.getAnalysisList(state),
  periodList: planning.selectors.getPeriodList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
  currencyList: configuration.selectors.getCurrencyList(state),
  commentsList: configuration.selectors.getCommentsList(state),
  forecasts: forecast.selectors.getForecasts(state),
  globalBudgetKpi: planning.selectors.getGlobalBudgetKpi(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  fetchGlobalForecastDetail: forecast.actions.fetchGlobalForecastDetail,
  fetchBudgetTypeList: configuration.actions.fetchBudgetTypeList,
  fetchAnalysisList: reports.actions.fetchAnalysisList,
  // fetchGlobalForecastDetailKPI: planning.actions.fetchGlobalForecastDetailKPI,
  approveGlobalForecast: forecast.actions.approveGlobalForecast,
  setDefaultForecast: forecast.actions.setDefaultForecast,
  publishGlobalForecast: forecast.actions.publishGlobalForecast,
  changeProjectionForecast: forecast.actions.changeProjectionForecast,
  fetchGlobalForecastEvolutionTable: forecast.actions.fetchGlobalForecastEvolutionTable,
  fetchDataEvolutionByOverallForecast: forecast.actions.fetchDataEvolutionByOverallForecast,
  fetchGlobalForecastComparisonTable: forecast.actions.fetchGlobalForecastComparisonTable,
  fetchDataComparativeByOverallForecast: forecast.actions.fetchDataComparativeByOverallForecast,
  unApplyRuleForecast: forecast.actions.unApplyRuleForecast,
  applyRuleForecast: forecast.actions.applyRuleForecast,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  fetchCurrencyList: configuration.actions.fetchCurrencyList,
  fetchCommentsList: configuration.actions.fetchCommentsList,
  fetchForecasts: forecast.actions.fetchForecasts,
  fetchGlobalBudgetKpi: planning.actions.fetchGlobalBudgetKpi,
  applyUnapplyMassiveGlobalForecast: forecast.actions.applyUnapplyMassiveGlobalForecast,
  shareLayout: control.actions.shareLayout,
}

GlobalForecastDetail.propTypes = {
  fetchDataEvolutionByOverallForecast: PropTypes.func,
  fetchDataComparativeByOverallForecast: PropTypes.func,
  unApplyRuleForecast: PropTypes.func,
  fetchAllDimensions: PropTypes.func,
  allDimensionsList: PropTypes.array,
  fetchCurrencyList: PropTypes.func,
  currencyList: PropTypes.shape({
    data: PropTypes.array,
  }),
  fetchCommentsList: PropTypes.func,
  commentsList: PropTypes.array,
  fetchForecasts: PropTypes.func,
  forecasts: PropTypes.shape({
    values: PropTypes.array,
  }),
  fetchGlobalBudgetKpi: PropTypes.func,
  globalBudgetKpi: PropTypes.any,
  globalForecastDetail: PropTypes.shape({
    status: PropTypes.string,
    budgets_ids: PropTypes.array,
  }),
  periodList: PropTypes.array,
  analysisList: PropTypes.shape({
    count: PropTypes.number,
  }),
  loggedUser: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalForecastDetail)
